// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1vymU","options":"AnswerScale_options__3pt55","selected":"AnswerScale_selected__21VhB"};